import Button from "../../components/common/Button/Button"
import { ArrowRightOutlined, CloseOutlined } from "@ant-design/icons"
import React from "react"

import "./styles.scss"
import BrowserRouter, { BrowserRoutes } from "../../stores/App/BrowserRouter"

function IncidentResponsePortalRedirectContainer() {
  return (
    <div className="incident-reponse-portal-redirect">
      <div className="information">
        <div className="title">
          Navigate to CORL's Incident Response Module (Beta)
        </div>
        <div className="content">
          The beta release of Incident Response includes two primary features:
          <ol type="1">
            <li>
              Ability for vendor organizations to share a designated Incident
              Response contact.
            </li>
            <li>
              A central portal to share incident-related information for
              significant episodic breaches and broad vulnerabilities.
            </li>
          </ol>
          Existing beta users may need to log in again to access the module.
          <br></br>
          <br></br>
          If your organization would like to participate as a Beta user of this
          new module, please&nbsp;
          <a
            className="hyperlink"
            href="mailto:corlvsm@corltech.com"
            target="_blank"
            rel="noreferrer"
          >
            contact us!
          </a>
          <br></br>
          <br></br>
          <a
            className="hyperlink"
            style={{ fontStyle: "italic" }}
            href="https://corltech.com/news/corl-technologies-introduces-proactive-third-party-incident-response-solution-for-healthcare/"
            target="_blank"
            rel="noreferrer"
          >
            Press Release
          </a>
        </div>
      </div>
      <div className="actions">
        <Button
          className="stay-here-button"
          color="corl-orange"
          icon={<CloseOutlined />}
          iconPosition={"left"}
          onClick={() => {
            BrowserRouter.push(BrowserRoutes.assessments)
          }}
        >
          Stay Here
        </Button>
        <Button
          className="continue-button"
          color="green"
          icon={<ArrowRightOutlined />}
          iconPosition={"left"}
          onClick={() => {
            window.open("https://supplier.corltech.com", "_blank")
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  )
}

export default IncidentResponsePortalRedirectContainer
